import { OrderItem } from '@/models/webshop.model';

export const areOrderItemsIdentical = (item1: OrderItem, item2: OrderItem): boolean =>
  item1.id !== item2.id &&
  item1.mlsId === item2.mlsId &&
  item1.patientId === item2.patientId &&
  item1.variantOptionValue === item2.variantOptionValue &&
  item1.isStock === item2.isStock &&
  item1.options === item2.options;

export const findIdenticalItem = (
  updatedItem: OrderItem,
  cartItems: OrderItem[]
): OrderItem | null =>
  cartItems.find((item) => areOrderItemsIdentical(updatedItem, item)) || null;

export const createMergedItem = (targetItem: OrderItem, sourceItem: OrderItem): OrderItem => {
  if (targetItem.isStock && targetItem.powerQuantities && sourceItem.powerQuantities) {
    try {
      const targetPowerQuantities = JSON.parse(targetItem.powerQuantities);
      const sourcePowerQuantities = JSON.parse(sourceItem.powerQuantities);

      const mergedPowerQuantities = [...targetPowerQuantities];

      sourcePowerQuantities.forEach((sourcePQ: { power: string; quantity: number }) => {
        const existingIndex = mergedPowerQuantities.findIndex(
          (targetPQ: { power: string; quantity: number }) => targetPQ.power === sourcePQ.power
        );

        if (existingIndex >= 0) {
          mergedPowerQuantities[existingIndex].quantity += sourcePQ.quantity;
        } else {
          mergedPowerQuantities.push({ ...sourcePQ });
        }
      });

      const totalQuantity = mergedPowerQuantities.reduce(
        (sum: number, pq: { quantity: number }) => sum + pq.quantity,
        0
      );

      return {
        ...targetItem,
        quantity: totalQuantity,
        powerQuantities: JSON.stringify(mergedPowerQuantities)
      };
    } catch (error) {
      return {
        ...targetItem,
        quantity: targetItem.quantity + sourceItem.quantity
      };
    }
  }

  return {
    ...targetItem,
    quantity: targetItem.quantity + sourceItem.quantity
  };
};

export interface MergeOperationResult {
  shouldMerge: boolean;
  targetItem: OrderItem | null;
  sourceItemId: string | null;
  mergedItem: OrderItem | null;
}

export const analyzeMergeOperation = (
  updatedItem: OrderItem,
  cartItems: OrderItem[]
): MergeOperationResult => {
  const identicalItem = findIdenticalItem(updatedItem, cartItems);

  if (!identicalItem) {
    return {
      shouldMerge: false,
      targetItem: null,
      sourceItemId: null,
      mergedItem: null
    };
  }

  const mergedItem = createMergedItem(identicalItem, updatedItem);

  return {
    shouldMerge: true,
    targetItem: identicalItem,
    sourceItemId: updatedItem.id || null,
    mergedItem
  };
};
